import { isEqual, pick } from '@lsfe/tools';
import { get, post } from './request';

const isProd = process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'staging';
const CachePromiseList = [];
const CacheRequest = [];

function matchRequest(method, { prefix = '' } = {}, addOrigin = false) {
    return function (url, param, options = {}) {
        const { cache = false, ...restOptions } = options;
        let req = url;
        let originUrl = url;
        if (typeof url === 'string') {
            req = {};
            req.url = addOrigin ? [window.location.origin, url].join('') : url;
            req.options = restOptions;
            req[method === get ? 'params' : 'body'] = param;
        }
        if (req.url.startsWith('/')) {
            req.url = prefix + req.url;
        }

        let rsPromise;
        if (cache) {
            // 比较的参照物
            const reference = {
                url: req.url,
                method: method === get ? 'get' : 'post',
                params: req.params,
                body: req.body
            };
            if(req.options.headers) reference.headers = req.options.headers;
            const itemCache = CachePromiseList.find(v => {
                return isEqual(pick(v, Object.keys(reference)), { ...reference });
            });
            if (itemCache) {
                rsPromise = itemCache.rsPromise;
            } else {
                rsPromise = method(req);
                CachePromiseList.push({ ...reference, rsPromise });
            }
        } else {
            rsPromise = method(req);
        }
        try {
            if(!isProd) {
                rsPromise.then(res => {
                    CacheRequest.unshift({date: +new Date(), url: originUrl, res, req});
                }).catch(errorInfo => {
                    CacheRequest.unshift({date: +new Date(), url: originUrl, errorInfo, req});
                });
                window.__dev__jiemo_api__cache = CacheRequest;
            }
        } catch (e) {
            console.log(e);
        }
        // 请求成功时统一处理
        if (window.__requestSuccCallback) {
            rsPromise.then(rs => {
                if (window.__requestSuccCallback) {
                    window.__requestSuccCallback(rs, req);
                }
            });
        }
        // 请求失败时统一处理
        if (window.__requestErrorCallback) {
            rsPromise.catch(e => {
                if (window.__requestErrorCallback) {
                    window.__requestErrorCallback(e, req);
                }
            });
        }
        return rsPromise;
    };
}

export default args => {
    return {
        get: matchRequest(get, args),
        post: matchRequest(post, args),
        hGet: matchRequest(get, args, true),
        hPost: matchRequest(post, args, true),
        go(url) {
            if (url.startsWith('/')) {
                url = ((args && args.prefix) || '') + url;
            }
            window.location.href = url;
        }
    };
};
